module.exports = __webpack_public_path__ + "static/media/digital-marketing.38d97b69.png";